var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E0FFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1429 7.76172C11.5143 7.76172 7.76196 11.5141 7.76196 16.1427C7.76196 20.7712 11.5143 24.5236 16.1429 24.5236C20.7715 24.5236 24.5239 20.7712 24.5239 16.1427C24.5239 11.5141 20.7715 7.76172 16.1429 7.76172ZM19.7757 14.7255C19.8426 14.6491 19.8935 14.56 19.9255 14.4636C19.9574 14.3671 19.9698 14.2653 19.9618 14.164C19.9538 14.0627 19.9256 13.9641 19.879 13.8738C19.8323 13.7836 19.768 13.7036 19.69 13.6386C19.612 13.5735 19.5217 13.5247 19.4245 13.4951C19.3273 13.4655 19.2252 13.4556 19.1242 13.466C19.0231 13.4764 18.9251 13.5069 18.8361 13.5557C18.747 13.6046 18.6685 13.6707 18.6054 13.7503L15.3292 17.681L13.634 15.985C13.4903 15.8462 13.2978 15.7694 13.098 15.7711C12.8983 15.7728 12.7072 15.853 12.5659 15.9942C12.4246 16.1355 12.3445 16.3266 12.3428 16.5264C12.341 16.7261 12.4178 16.9186 12.5566 17.0623L14.8423 19.348C14.9172 19.4228 15.0068 19.4812 15.1055 19.5195C15.2042 19.5577 15.3098 19.575 15.4155 19.5702C15.5212 19.5654 15.6248 19.5386 15.7196 19.4916C15.8144 19.4445 15.8984 19.3783 15.9662 19.297L19.7757 14.7255Z",
    fill: "#24AF22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaved);
export default __webpack_public_path__ + "static/media/icon-saved.275eddbf61d72389e416b946e81e6c40.svg";
export { ForwardRef as ReactComponent };